// local
import { trackEvent } from '../helpers.js';

const EVENT_NAME = 'fragment_click';

export function trackFragmentIdentifierClicks() {
  document.addEventListener('click', handleLinkInteraction, {
    capture: true,
  });
}

function handleLinkInteraction(event: MouseEvent) {
  const target = event.target as HTMLElement;
  const href = target.closest('a')?.getAttribute('href');

  if (href && href.startsWith('#')) {
    const fragment = href.substring(1);

    trackEvent(EVENT_NAME, {
      fragment_id: fragment,
      fragment_text: target.textContent?.trim() || '',
    });
  }
}
